export default "__VITE_ASSET__Boft8Css__"